import { Image, Text, useColorModeValue } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { consts as commonConsts } from '@finley-technologies/common';

import { colors } from 'packages/common-frontend/colors';
import {
  InitialBadge,
  LogoBadge,
} from 'packages/common-frontend/components/Badge';
import FinleyLogo from 'packages/common-frontend/images/Logo-square.svg';

export const UnkownResponsiblePartyBadge: React.FC<{}> = () => {
  return (
    <InitialBadge
      bg="gray.300"
      withTooltip
      text="?"
      tooltipLabel="Other Organization"
    />
  );
};

export const OtherResponsiblePartyBadge: React.FC<{
  responsiblePartyName: string;
}> = ({ responsiblePartyName }) => {
  const color = useColorModeValue('gray.500', 'gray.300');
  return <InitialBadge bg={color} withTooltip text={responsiblePartyName} />;
};

export const MainResponsiblePartyBadge: React.FC<{
  responsiblePartyName: string;
}> = ({ responsiblePartyName }) => {
  const color = useColorModeValue(colors.poppy[500], colors.millet[100]);
  const textColor = useColorModeValue('white', colors.poppy[500]);

  return (
    <InitialBadge
      bg={color}
      text={responsiblePartyName}
      textColor={textColor}
      withTooltip
    />
  );
};

export const FinleyResponsiblePartyBadge: React.FC<{}> = () => {
  const color = useColorModeValue(colors.aurora[800], colors.millet[100]);
  return (
    <LogoBadge
      bg={color}
      logo={<Image src={FinleyLogo} alt="Logo" boxSize="16px" />}
      withTooltip
      tooltipLabel="Finley"
    />
  );
};

export const ResponsiblePartyBadge: React.FC<{
  organizationId: string;
  responsiblePartyId: string;
  responsiblePartyName: string;
}> = ({ organizationId, responsiblePartyId, responsiblePartyName }) => {
  if (responsiblePartyId === commonConsts.specialOrganizationIds.finley) {
    return <FinleyResponsiblePartyBadge />;
  }
  if (organizationId === responsiblePartyId) {
    return (
      <MainResponsiblePartyBadge responsiblePartyName={responsiblePartyName} />
    );
  }
  return (
    <OtherResponsiblePartyBadge responsiblePartyName={responsiblePartyName} />
  );
};

export const ResponsibleParties: React.FC<{
  responsibleParties: { responsibleParty: { id: string; name: string } }[];
  requestingOrganizationId: string;
}> = ({ responsibleParties, requestingOrganizationId }) => {
  const currentResponibleParties =
    responsibleParties.length > 1
      ? _.filter(
          responsibleParties,
          ({ responsibleParty: { id: currentResponsiblePartyId } }) =>
            currentResponsiblePartyId !==
            commonConsts.specialOrganizationIds.finley,
        )
      : responsibleParties;

  return (
    <>
      {_.map(
        currentResponibleParties,
        ({
          responsibleParty: {
            id: currentResponsiblePartyId,
            name: currentResponsiblePartyName,
          },
        }) => (
          <Text
            fontWeight={
              currentResponsiblePartyId === requestingOrganizationId
                ? 'bold'
                : undefined
            }
            key={currentResponsiblePartyId}
          >
            {currentResponsiblePartyName}
          </Text>
        ),
      )}
    </>
  );
};
